import { render, staticRenderFns } from "./Grants.vue?vue&type=template&id=25723668&scoped=true&"
import script from "./Grants.vue?vue&type=script&lang=js&"
export * from "./Grants.vue?vue&type=script&lang=js&"
import style0 from "./Grants.vue?vue&type=style&index=0&id=25723668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25723668",
  null
  
)

export default component.exports